import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@vds/buttons';
import { v4 as uuidv4 } from 'uuid';

import { VDSModal as Modal } from '../../../common/Modal/VDSModal';
import { isMobile as isMobileFunc } from '../../../common/Helpers/useragent';
import MainView from '../MainView';
import { ButtonContainer } from './NBSModal.styles';
import { isWHWP2 } from '../../../common/Helpers';

const NBSModalStyle = styled(Modal)`
  max-width: 700px !important;
  width: 700px;
  [class^='ModalDialogWrapper'] {
    overflow: auto;
    padding-top: ${isMobileFunc() ? '40px' : ''};
  }
  body {
    display: none;
  }
`;

const initialized = {
  initial: false,
  setValue(data = false) {
    this.initial = data;
  },
};
const NBSModal = (props) => {
  initialized.setValue(false);
  const isMobile = isMobileFunc();
  const buttonSize = isMobile ? '100%' : '25%';
  const elementId = uuidv4();

  const handleOpenChange = (val) => {
    if (!val) {
      props.change();
      if (window?.vztag?.api?.dispatch) {
        window.vztag.api.dispatch('closeView', {
          name: elementId,
          selector: `#${elementId}`,
        });
      }
    }
  };

  return (
    <NBSModalStyle opened={props.isOpen} data-track = {isWHWP2() && props?.isDowngradeRedemption ? '{}' : ''} onOpenedChange={handleOpenChange} disableTaggingEvent contentContainer="nbsModalWrapper" id="nbs-modal">
      <MainView elementId={elementId} initialized={initialized} />
      <ButtonContainer>
        <Button width={buttonSize} size="large" data-track = {isWHWP2() && props?.isDowngradeRedemption ? '{}' : ''} onClick={() => props.change()}>
          Close
        </Button>
      </ButtonContainer>
    </NBSModalStyle>
  );
};

NBSModal.propTypes = {
  isOpen: PropTypes.bool,
  change: PropTypes.func,
  isDowngradeRedemption: PropTypes.bool,
};

export default React.memo(NBSModal);
